export const enum CountrySortEnum {
  priority = 'priority',
}
